import { createEffect } from 'effector';
import { getPrinters, createPrinter, deletePrinter } from '../../services/printersService';
import { CreatePrinterPayload, Printer } from '../../types/printers.types';

export const fetchPrintersFx = createEffect<void, Printer[], Error>(async () => {
    return await getPrinters();
});

export const createPrinterFx = createEffect<CreatePrinterPayload, Printer, Error>(async (payload) => {
    return await createPrinter(payload);
});

export const deletePrinterFx = createEffect<string, void, Error>(async (id) => {
    return await deletePrinter(id);
});
